import { freeze } from 'icepick';
import { type SetAction, SET } from './actions.tsx';

export type ErrorState = {
	message?: string;
};

type Action = SetAction;

export const initialState: ErrorState = freeze({
	message: undefined,
});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: ErrorState = initialState, action: Action) => {
	switch (action.type) {
		case SET: {
			return freeze({ message: action.payload.message });
		}
		default:
			return state;
	}
};
